import { AssetRow, NamirasoftBalanceServer, SummaryRow } from "namirasoft-balance";
import { TimeOperation } from "namirasoft-core";
import { NSLoading } from "namirasoft-site-react";
import { useEffect, useState } from "react";
import { SummaryStatementLine } from "./SummaryStatementLine";
import Styles from "./SummaryStatement.module.css";

interface BalanceOverviewProps
{
    server: NamirasoftBalanceServer;
}

export function BalanceOverview(props: BalanceOverviewProps)
{
    const [rows, setRows] = useState<SummaryRow[] | null>(null);
    const [assets, setAssets] = useState<Record<string, AssetRow>>({});

    useEffect(() =>
    {
        let cancelled = false;
        Promise.all([
            props.server.summary.Last([], null, null, [], null, null, {}),
            props.server.asset.List(null, 1, 500, [], null)
        ]).then(([lastRes, assetsRes]) =>
        {
            if (cancelled) return;
            const map: Record<string, AssetRow> = {};
            assetsRes.rows.forEach(a => { map[a.id] = a; });
            setAssets(map);
            setRows(lastRes.rows);
        });
        return () => { cancelled = true; };
        // eslint-disable-next-line
    }, []);

    if (rows === null)
        return <NSLoading title="Loading balances..." />;

    if (rows.length === 0)
        return null;

    const sorted = [...rows].sort((a, b) =>
    {
        const nameA = assets[a.asset_id]?.name ?? "";
        const nameB = assets[b.asset_id]?.name ?? "";
        return nameA.localeCompare(nameB);
    });

    return (
        <div className={Styles.statement_container}>
            {sorted.map(row =>
            {
                const asset = assets[row.asset_id];
                const assetName = asset?.name ?? "";
                const monthLabel = TimeOperation.MONTH_NAMES[(row.month - 1) % 12] ?? String(row.month);
                return (
                    <SummaryStatementLine
                        key={row.id}
                        row={row}
                        assetName={assetName}
                        title={`${assetName || "Asset"} — ${monthLabel} ${row.year}`}
                        subtitle="Latest monthly statement"
                    />
                );
            })}
        </div>
    );
}